import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-892d9b3c")

_pushScopeId("data-v-892d9b3c")
const _hoisted_1 = { class: "container main-page-container col-xl-7 col-sm-10 col-12" }
const _hoisted_2 = { class: "page-header-title" }
const _hoisted_3 = { class: "row mt-md-5 col-md-12 offset-md-0 col-sm-10 offset-sm-1 p-0" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "d-flex flex-column greeting-content" }
const _hoisted_6 = { class: "greeting-user" }
const _hoisted_7 = { class: "greeting-todo" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col px-4" }
const _hoisted_10 = { class: "d-flex justify-content-sm-around row" }
const _hoisted_11 = { class: "col-lg-3 col-6 px-lg-4" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "col-12 icon-wrapper" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-documents fs-44" })
], -1)
const _hoisted_14 = { class: "col-12 text-icon" }
const _hoisted_15 = { class: "col-lg-3 col-6 px-lg-4" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "col-12 icon-wrapper" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-catalog fs-44" })
], -1)
const _hoisted_18 = { class: "col-12 text-icon" }
const _hoisted_19 = { class: "col-lg-3 col-6 px-lg-4" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "col-12 icon-wrapper" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-orders fs-44" })
], -1)
const _hoisted_22 = { class: "col-12 text-icon" }
const _hoisted_23 = { class: "col-lg-3 col-6 px-lg-4" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "col-12 icon-wrapper" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-settings fs-44" })
], -1)
const _hoisted_26 = { class: "col-12 text-icon" }
const _hoisted_27 = {
  key: 0,
  class: "py-4"
}
const _hoisted_28 = { class: "h4 text-dark" }
const _hoisted_29 = { class: "d-flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('navbar.menuBO')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString($setup.greeting), 1),
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('home.whatWouldYouLikeToDo')), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: "/providers",
              class: "circle-nav-button",
              style: {"background":"#0bc7d9"}
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('navbar.providers')), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_router_link, {
              to: "/catalog",
              class: "circle-nav-button",
              style: {"background":"#f6ae28"}
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('navbar.products')), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode(_component_router_link, {
              to: "/orders",
              class: "circle-nav-button",
              style: {"background":"#fd8180"}
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('orders.orders')), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_23, [
            _createVNode(_component_router_link, {
              class: "circle-nav-button",
              to: "/settings",
              style: {"background":"#2673a3"}
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('navbar.settings')), 1)
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    ($setup.showAlert)
      ? (_openBlock(), _createBlock("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('home.alert.header')), 1),
          _createVNode(_component_router_link, {
            class: "round-border text-dark d-flex justify-content-between border p-3 mb-2",
            to: '/catalog',
            onClick: $setup.setFilter
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_29, [
                _createVNode("div", {
                  class: ["icon-f icon-info-solid my-auto", [$setup.locale === 'he-IL'?'pl-2':'pr-2']],
                  style: {"color":"#fd695a"}
                }, null, 2),
                _createVNode("div", null, _toDisplayString(_ctx.$t(`home.alert.title`)), 1)
              ]),
              _createVNode("div", {
                class: ["icon-f my-auto", [$setup.locale === 'he-IL'?'icon-calendar-arrow-left':'icon-calendar-arrow-right']]
              }, null, 2)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
})